import React, { useCallback, useEffect } from 'react'
import { createContext, useContextSelector } from 'use-context-selector'
import { useAppContextState } from 'app/@hooks'
import { postSubmit } from 'ui-seeker/utils'
import { AppDatesContext } from './index'

const Context = createContext({})

const initialState = {
    location_category: null,
    location_name: null,
    nights: null,
    occupancy: null,
    occupation_dates: {},
    site_name: null,
    type_accommodation: null,
    latestSearchDate: {},
    isLoading: false,
}

export function AppLocationDataProvider({ children }) {

    const { state, updateState } = useAppContextState(initialState)
    const monthYear = useContextSelector(AppDatesContext, ({ state }) => state.monthYear)
    const startDate = useContextSelector(AppDatesContext, ({ state }) => state.startDate)
    const endDate = useContextSelector(AppDatesContext, ({ state }) => state.endDate)

    const getLocationData = useCallback(() => {
        updateState({ isLoading: true })
        postSubmit('/api/location/occupation', { dateRange: monthYear, startDate, endDate })
            .then(res => {
                updateState({...res, isLoading: false})
            })
            .catch(err => console.log(err))
    }, [updateState, monthYear, startDate, endDate])

    useEffect(() => {
        if((monthYear !== 'custom' && !!monthYear) || (monthYear === 'custom' && (startDate && endDate))) getLocationData()
    }, [getLocationData, monthYear, startDate, endDate])

    return <Context.Provider value={{ state, updateState }}>{children}</Context.Provider>
}

export default Context;